// skio:filter:start
// Only the active subscription platform's selling plan allocations (Theme settings > Subscriptions, via window.subscriptionAppId).
function skioAllocs(variant, prod) {
    const ids = ((prod && prod.selling_plan_groups) || [])
        .filter(g => String(g.app_id) === String(window.subscriptionAppId))
        .map(g => g.id);
    return ((variant && variant.selling_plan_allocations) || [])
        .filter(a => ids.includes(a.selling_plan_group_id));
}
// skio:filter:end

(function () {

    /********************* Setup *********************/

        // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[data-section="${sectionID}"]`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product bundle section with ID ${sectionID} not found.`);
        return;
    }

    // get product data embedded as JSON in the section liquid
    const product = JSON.parse(section.querySelector(".productBundleV1JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productBundleV1VariantJSON").textContent);

    // map of variant id to its maltertech.ongoing_price metafield (cents, null when unset)
    const variantIDtoOngoingPrice = JSON.parse(section.querySelector(".productBundleV1VariantIDtoOngoingPriceJSON").textContent);

    // map of variant id to its custom.dosage_with_text metafield, the same per dose copy the selling card shows
    const variantIDtoDose = JSON.parse(section.querySelector(".productBundleV1VariantIDtoDoseJSON").textContent);

    /********************* Product Swiper *********************/

        // setup product swiper, all elements scoped to this section
    const productSwiper = new Swiper(section.querySelector(".productBundleV1VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: section.querySelector(".productBundleV1VisualSwiperNext"),
                prevEl: section.querySelector(".productBundleV1VisualSwiperPrev"),
            },
            pagination: {
                el: section.querySelector(".productBundleV1VisualSwiperPag"),
                clickable: true
            },
            on: {
                slideChange: function () {
                    // pause all videos when the slide changes
                    section.querySelectorAll(".productBundleV1VisualSwiperSlide video")?.forEach(element => {
                        element.pause();
                    });
                }
            }
        });

    // play video on slide play click
    section.querySelectorAll(".productBundleV1VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get the video for this slide
            const video = this.closest(".productBundleV1VisualSwiperSlide").querySelector("video");
            if (!video) {
                return;
            }

            // remove the play button if it has not already been removed
            this.querySelector(".productBundleV1VisualSwiperSlidePlay")?.remove();

            // show controls and play
            video.controls = true;
            video.play();
        });
    });

    /********************* Selling Plan *********************/

    // sync the custom frequency dropdown with its hidden native select
    function initializeCustomSelect() {
        const select = section.querySelector(".productBundleV1SellingLabelBodyBottomWrapContentSelect");
        const details = section.querySelector(".customDetails");
        if (!select || !details) {
            return;
        }

        const summary = details.querySelector(".customDetailsTitle");
        const options = details.querySelectorAll(".customOption");

        // seed the summary label from the current select value
        const initialOption = select.options[select.selectedIndex];
        if (summary && initialOption) {
            summary.firstElementChild.textContent = initialOption.textContent.trim();
        }

        // on option click, write back to the native select and update the summary
        options.forEach(option => {
            option.addEventListener("click", () => {
                select.value = option.dataset.value;
                if (summary) {
                    summary.firstElementChild.textContent = option.textContent.trim();
                }
                options.forEach(opt => opt.classList.remove("selected"));
                option.classList.add("selected");
                details.removeAttribute("open");
            });
        });
    }

    // fill the save badges from the active variant pricing
    function updateSavingsDisplay() {
        if (!activeVariant) {
            return;
        }

        const subSave = section.querySelector(".productBundleV1SellingTagDiscountSub");
        const oneTimeSave = section.querySelector(".productBundleV1SellingTagDiscountOne");
        if (!subSave) {
            return;
        }

        // subscription saving is compare (or regular) price minus the selling plan price
        // skio:filter:start
        // was: const sellingPlanPrice = activeVariant.selling_plan_allocations?.[0]?.price;
        const sellingPlanPrice = skioAllocs(activeVariant, product)?.[0]?.price;
        // skio:filter:end
        if (sellingPlanPrice === undefined) {
            return;
        }
        const subTotal = activeVariant.compare_at_price
            ? activeVariant.compare_at_price - sellingPlanPrice
            : activeVariant.price - sellingPlanPrice;
        subSave.innerHTML = `SAVE ${price(subTotal, true)}`;

        // green subscription header shows the first-order discount percentage
        const basePrice = activeVariant.compare_at_price || activeVariant.price;
        const discountPercent = Math.round((basePrice - sellingPlanPrice) / basePrice * 100);

        // ongoing price comes from the variant's maltertech.ongoing_price metafield (cents), falling back to the selling plan price
        let ongoingPrice = sellingPlanPrice;
        const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
        if (ongoingPriceMetafield != null) {
            ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
        }
        const ongoingPercent = Math.round((basePrice - ongoingPrice) / basePrice * 100);

        // first bullet shows the ongoing per-month price after the first order plus the ongoing discount
        const bulletSave = section.querySelector(".productBundleV1SellingLabelBodyBottomWrapContentBulletsItemSave");
        if (bulletSave) {
            bulletSave.innerHTML = `
                <span class="productBundleV1SellingLabelBodyBottomWrapContentBulletsItemSavePrice">${price(ongoingPrice, true)}/mo after first order</span>
                <span class="productBundleV1SellingLabelBodyBottomWrapContentBulletsItemSaveOngoing">(${ongoingPercent}% OFF ongoing)</span>
            `;
        }

        // one-time saving only shows when there is a compare-at markdown
        if (oneTimeSave) {
            const oneTimeTotal = activeVariant.compare_at_price - activeVariant.price;
            if (oneTimeTotal > 0) {
                oneTimeSave.innerHTML = `SAVE ${price(oneTimeTotal, true)}`;
                oneTimeSave.classList.remove("hidden");
            } else {
                oneTimeSave.classList.add("hidden");
            }
        }
    }

    // update the ATC price to reflect the selected sub/once option
    function updateProduct() {
        let total = activeVariant.price;
        let compareAtPrice = activeVariant.compare_at_price;

        // subscription pricing comes from the first selling plan allocation
        if (section.querySelector(".productBundleV1SellingLabelInput:checked")?.value === "sub") {
            // skio:filter:start
            // was: total = activeVariant.selling_plan_allocations[0].price;
            total = skioAllocs(activeVariant, product)[0].price;
            // skio:filter:end
            // skio:filter:start
            // was: compareAtPrice = activeVariant.selling_plan_allocations[0].compare_at_price;
            compareAtPrice = skioAllocs(activeVariant, product)[0].compare_at_price;
            // skio:filter:end
        }

        // write the real price and only show a compare price when it is higher
        section.querySelector(".productBundleV1ATCPriceReal").textContent = price(total, true);
        const compareEl = section.querySelector(".productBundleV1ATCPriceRealCompare");
        compareEl.textContent = "";
        if (compareAtPrice > total) {
            compareEl.textContent = price(compareAtPrice, true);
        }
    }

    // re-price when the sub/once selection changes
    section.querySelectorAll(".productBundleV1SellingLabelInput").forEach(element => {
        element.addEventListener("change", updateProduct);
    });

    /********************* Add To Cart *********************/

    section.querySelector(".productBundleV1ATC").addEventListener("click", async function () {
        // add loading animation
        this.classList.add("loading");

        const formData = {
            items: [{
                quantity: 1,
                id: parseInt(this.dataset.id),
            }]
        };

        // attach the chosen selling plan when subscribing
        if (section.querySelector(".productBundleV1SellingLabelInput:checked")?.value === "sub") {
            formData.items[0].selling_plan = parseInt(section.querySelector(".productBundleV1SellingLabelBodyBottomWrapContentSelect").value);
        }

        await addProduct(formData);

        // remove loading animation and open the cart
        this.classList.remove("loading");
        await openCart();
    });

    /********************* Init *********************/

    initializeCustomSelect();
    updateSavingsDisplay();
    updateProduct();

    // font fix override for shopify payments (make b element normal weight)
    document.addEventListener("DOMContentLoaded", function () {
        customElements.whenDefined("shopify-payment-terms").then(() => {
            customElements.whenDefined("shop-pay-installments-banner").then(() => {
                section.querySelector("shopify-payment-terms")?.shadowRoot?.querySelector("shop-pay-installments-banner")?.shadowRoot?.querySelector("b")?.setAttribute("style", "font-weight: 400;");
            });
        });
    });

    /**************
     Product Sticky Bar (Mobile)
     ***************/

    // the sticky bar renders outside the section element, so match it on this section's id
    const productBundleV1Sticky = document.querySelector(`.productBundleV1Sticky[data-product-sticky="${sectionID}"]`);
    if (productBundleV1Sticky) {
        const productBundleV1ATCEl = section.querySelector(".productBundleV1ATC");
        const productBundleV1StickySubInput = productBundleV1Sticky.querySelector('.productBundleV1StickyTopLeftBodyOptionsLabelInput[value="sub"]');
        const productBundleV1StickyDose = productBundleV1Sticky.querySelector(".productBundleV1StickyBottomDose");
        const productBundleV1StickyPrice = productBundleV1Sticky.querySelector(".productBundleV1StickyBottomPrice");
        const productBundleV1StickyATC = productBundleV1Sticky.querySelector(".productBundleV1StickyTopATC");

        // several product sections can share a page, only the first bar whose section is rendered may show
        function ownsSticky() {
            const owner = [...document.querySelectorAll("[data-product-sticky]")].find(bar => {
                const barSection = document.querySelector(`[data-section="${bar.dataset.productSticky}"], [id="${bar.dataset.productSticky}"]`);
                return barSection && barSection.offsetParent !== null;
            });
            return owner != null && owner.dataset.productSticky === sectionID;
        }

        // show the sticky bar whenever the main ATC isn't in the viewport (above or below)
        function toggleStickyVisibility() {
            const rect = productBundleV1ATCEl.getBoundingClientRect();
            const inView = rect.bottom > 0 && rect.top < window.innerHeight;
            productBundleV1Sticky.classList.toggle("visible", !inView && ownsSticky());
        }

        window.addEventListener("scroll", toggleStickyVisibility, {passive: true});
        toggleStickyVisibility();

        // sync the sticky bar choice into the main selling radio so the rest of the page updates
        productBundleV1Sticky.querySelectorAll(".productBundleV1StickyTopLeftBodyOptionsLabelInput").forEach(input => {
            input.addEventListener("change", function () {
                const mainInput = section.querySelector(`.productBundleV1SellingLabelInput.${this.value}`);
                if (mainInput) {
                    mainInput.checked = true;
                    mainInput.dispatchEvent(new Event("change", {bubbles: true}));
                }
                updateProductSticky();
            });
        });

        // sticky ATC reuses the same add-to-cart flow as the main button
        productBundleV1StickyATC.addEventListener("click", function () {
            productBundleV1ATCEl.click();
        });

        // refresh dose visibility and price text from current variant + selling state
        function updateProductSticky() {
            const subChecked = productBundleV1StickySubInput.checked;

            // dose price comes from the active variant's dosage metafield, hidden when it has no price
            const dosePrice = (variantIDtoDose[activeVariant.id] || "").match(/\$\d+(\.\d+)?/);
            productBundleV1StickyDose.textContent = dosePrice ? `${dosePrice[0]}/dose` : "";

            // dose only shows for subscription
            productBundleV1StickyDose.classList.toggle("active", subChecked && dosePrice != null);

            // price text differs by selling type
            if (subChecked) {
                // skio:filter:start
                // was: const subPrice = price(activeVariant.selling_plan_allocations[0].price, true);
                const subPrice = price(skioAllocs(activeVariant, product)[0].price, true);
                // skio:filter:end

                // ongoing price comes from the variant's maltertech.ongoing_price metafield, fall back to the selling plan price
                // skio:filter:start
                // was: let ongoingPrice = activeVariant.selling_plan_allocations[0].price;
                let ongoingPrice = skioAllocs(activeVariant, product)[0].price;
                // skio:filter:end
                const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
                if (ongoingPriceMetafield != null) {
                    ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
                }

                productBundleV1StickyPrice.innerHTML = `<strong>${subPrice} </strong>+ FREE shipping* - <em>${price(ongoingPrice, true)}/mo after, cancel anytime</em>`;
            } else {
                const oncePrice = price(activeVariant.price, true);
                productBundleV1StickyPrice.innerHTML = `<strong>${oncePrice}</strong> + $9.99 shipping*`;
            }
        }

        // re-render whenever the main selling radios change
        section.querySelectorAll(".productBundleV1SellingLabelInput").forEach(input => {
            input.addEventListener("change", updateProductSticky);
        });
        updateProductSticky();
    }

}());
